import { AfterViewInit, Component, Input } from '@angular/core';
import { LoadingScreenModel } from './loading-screen.model';

@Component({
    selector: 'pace-core-loading-screen',
    templateUrl: './loading-screen.component.html',
    styleUrls: ['./loading-screen.component.scss'],
    standalone: false,
})
export class LoadingScreenComponent implements AfterViewInit {
    @Input()
    public model: LoadingScreenModel;

    public ngAfterViewInit(): void {
        this.model.triggerViewRendered();
    }
}
